import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export type CustomComponentsAreaProps = {
  width?: string | number;
};

export const MultiSelectTrigger = styled.div`
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  opacity: ${({ disabled }) => (disabled ? '0.6' : '1')};
  background-color: ${themeColor('background.primary')};

  &:hover * {
    cursor: pointer;
  }

  i {
    background-color: ${themeColor('background.primary', { dark: 'background.secondary' })};
  }

  .icon-custom {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    z-index: 0;
  }

  .ant-input-group-addon {
    border: none;
    border-bottom: 1px solid ${themeColor('divider.primary')};
    background-color: transparent;
  }

  svg {
    width: 12px;
    height: 12px;
    color: ${themeColor('element.secondary', { dark: 'element.secondary' })};
    font-size: 12px;
    line-height: 12px;
  }

  &[data-active='true'] .mt-input {
    border-color: ${themeColor('brand.primary')} !important;
  }
`;

export const MultiSelectOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled.div<{ height?: number }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    max-height: ${({ height }) => height || 400}px;
    overflow: auto;
  }

  .ant-checkbox-inner {
    border-color: ${themeColor('brand.primary')} !important;
    background-color: ${({ theme }) => theme.colors.background.primary};
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: ${themeColor('brand.primary', { dark: 'brand.secondary' })} !important;
    }
  }

  .ant-checkbox-group-item {
    padding: 8px 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: all 0.3s;

    &:hover {
      overflow: visible;
    }

    & > :last-child {
      background-color: ${themeColor('background.primary', { dark: 'background.secondary' })};
      color: ${themeColor('element.primary', { dark: 'element.secondary' })};
      padding-top: 8px;
      padding-bottom: 8px;
      padding-right: 8px;
      border-radius: 0 4px 4px 0;
    }
  }

  .ant-checkbox-wrapper-disabled {
    display: none;
  }
`;

export const PortalSelect = styled.div<CustomComponentsAreaProps>`
  .ant-popover {
    width: ${({ width }) => (Number.isInteger(width) ? `${width}px` : width)} !important;
  }
`;

export const SearchWrapper = styled.div`
  div {
    border: 1.5px solid ${({ theme }) => theme.colors.divider.primary};
    background-color: ${themeColor('background.primary')};
    border-radius: 8px;
    height: 40px;
  }
`;
